<template>
  <i :class="classes" :style="stylesIcon"></i>
</template>
<script>
const prefixCls = 'aid'
export default {
  name: 'TIcon',
  props: {
    type: String,
    color: String,
    size: [ Number, String ],
    bgShape: {
      // 自定义验证函数进行props验证
      type: String,
      validator (value) {
        return [ 'circle', 'rectangle' ].includes(value)
      }
    },
    background: String,
    gradient: {
      type: String,
      validator (value) {
        return [ 'primary', 'success', 'info', 'warning', 'danger' ].includes(value)
      }
    },
    rotate: {
      type: String,
      validator (value) {
        return [ '90', '180', '270' ].includes(value)
      }
    }
  },
  computed: {
    classes () {
      return [
        `${prefixCls}`,
        `${prefixCls}-${this.type}`,
        {
          [`icon-gradient-${this.gradient}`]: !!this.gradient,
          [`rotate-${this.rotate}`]: !!this.rotate,
          [`icon-bg--${this.bgShape}`]: !!this.bgShape
        }
      ]
    },
    stylesIcon () {
      let style = {}
      if (this.size) {
        style[ 'font-size' ] = `${this.size}px`
      }
      if (this.color) {
        style.color = this.color
      }
      return style
    }
  }
}
</script>



// WEBPACK FOOTER //
// icon.vue?9fd83fd2